import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress";
import { routes } from "./routes";
import { REDIRECT_PATH } from "@/config/setting";

NProgress.configure({
  speed: 200,
  minimum: 0.02,
  trickleSpeed: 200,
  showSpinner: false,
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from) => {
  if (!from.path.includes(REDIRECT_PATH)) {
    NProgress.start();
  }
});

router.afterEach((to) => {
  if (!to.path.includes(REDIRECT_PATH) && NProgress.isStarted()) {
    setTimeout(() => {
      NProgress.done();
    }, 200);
  }
});

export default router;
